import BaseCommand from "@/models/api/commands/BaseCommand";

export class AddItemCommand extends BaseCommand {
  CommandName = "AddItem";
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
